import React, { Component } from 'react';
import axios from "axios";
import { API_URL } from "../../config/Config";
import { setBusIssue } from "../../redux/actions/ticket";
import { connect } from "react-redux";
import SaveLoader from '../../components/loader/SaveLoader';


class CallBack extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true
        }
    }

    async componentDidMount() {
        await this.setState({ loading: true });
        const urlParams = new URLSearchParams(window.location.search);
        const authority = urlParams.get('authority');
        console.log(authority);
        try {
            const callback = await axios.get(API_URL + 'callback?authority=' + authority)
            console.log(callback);
            if (callback.data.status === 0) {
                alert('unfortunately your payment is not Completed');
                window.location.replace('/');
            }
            if (callback.data.status === 1) {
                this.props.setBusIssue(callback.data);
                alert("Thank you For choosing us you can download your ticket in next page");
                window.location.replace('/sales-invoice');
            }
            if (callback.data.status === 2) {
                alert(callback.data.message);
                window.location.replace('/');
            }
        } catch (err) {
            console.log('error');
            console.log(err);
        }
        await this.setState({ loading: false });
    }

    render() {
        const { loading } = this.state;
        return (
            <div className="Ticketreview pt-5 mt-5 payment-getway" >

                {loading && <SaveLoader />}
                Transaction Response ...
            </div>
        )
    }
}


const mapDispatchToProps = dispatch => {
    return {
        setBusIssue: (ticket) => {
            dispatch(setBusIssue(ticket))
        }
    }
};

export default connect(null, mapDispatchToProps)(CallBack);


// WEBPACK FOOTER //
// ./src/containers/search/callBack.jsx